/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceBrokerPayloadDto
 */
export interface ReplaceBrokerPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    status: ReplaceBrokerPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    type?: ReplaceBrokerPayloadDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    group?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    brokerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    legalEntityName: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    claimsEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    financeEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    website?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReplaceBrokerPayloadDto
     */
    hasToba: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReplaceBrokerPayloadDto
     */
    tobaCompletionDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ReplaceBrokerPayloadDto
     */
    hasKyc: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReplaceBrokerPayloadDto
     */
    kycCompletionDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReplaceBrokerPayloadDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReplaceBrokerPayloadDto
     */
    state?: string;
}


/**
 * @export
 */
export const ReplaceBrokerPayloadDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type ReplaceBrokerPayloadDtoStatusEnum = typeof ReplaceBrokerPayloadDtoStatusEnum[keyof typeof ReplaceBrokerPayloadDtoStatusEnum];

/**
 * @export
 */
export const ReplaceBrokerPayloadDtoTypeEnum = {
    Wholesale: 'Wholesale',
    Retail: 'Retail'
} as const;
export type ReplaceBrokerPayloadDtoTypeEnum = typeof ReplaceBrokerPayloadDtoTypeEnum[keyof typeof ReplaceBrokerPayloadDtoTypeEnum];


/**
 * Check if a given object implements the ReplaceBrokerPayloadDto interface.
 */
export function instanceOfReplaceBrokerPayloadDto(value: object): value is ReplaceBrokerPayloadDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('legalEntityName' in value) || value['legalEntityName'] === undefined) return false;
    if (!('hasToba' in value) || value['hasToba'] === undefined) return false;
    if (!('hasKyc' in value) || value['hasKyc'] === undefined) return false;
    return true;
}

export function ReplaceBrokerPayloadDtoFromJSON(json: any): ReplaceBrokerPayloadDto {
    return ReplaceBrokerPayloadDtoFromJSONTyped(json, false);
}

export function ReplaceBrokerPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceBrokerPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'group': json['group'] == null ? undefined : json['group'],
        'name': json['name'],
        'brokerEmail': json['brokerEmail'] == null ? undefined : json['brokerEmail'],
        'legalEntityName': json['legalEntityName'],
        'claimsEmail': json['claimsEmail'] == null ? undefined : json['claimsEmail'],
        'financeEmail': json['financeEmail'] == null ? undefined : json['financeEmail'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'address': json['address'] == null ? undefined : json['address'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'website': json['website'] == null ? undefined : json['website'],
        'hasToba': json['hasToba'],
        'tobaCompletionDate': json['tobaCompletionDate'] == null ? undefined : (new Date(json['tobaCompletionDate'])),
        'hasKyc': json['hasKyc'],
        'kycCompletionDate': json['kycCompletionDate'] == null ? undefined : (new Date(json['kycCompletionDate'])),
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function ReplaceBrokerPayloadDtoToJSON(json: any): ReplaceBrokerPayloadDto {
    return ReplaceBrokerPayloadDtoToJSONTyped(json, false);
}

export function ReplaceBrokerPayloadDtoToJSONTyped(value?: ReplaceBrokerPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'type': value['type'],
        'group': value['group'],
        'name': value['name'],
        'brokerEmail': value['brokerEmail'],
        'legalEntityName': value['legalEntityName'],
        'claimsEmail': value['claimsEmail'],
        'financeEmail': value['financeEmail'],
        'phoneNumber': value['phoneNumber'],
        'address': value['address'],
        'postcode': value['postcode'],
        'city': value['city'],
        'country': value['country'],
        'website': value['website'],
        'hasToba': value['hasToba'],
        'tobaCompletionDate': value['tobaCompletionDate'] == null ? undefined : ((value['tobaCompletionDate']).toISOString()),
        'hasKyc': value['hasKyc'],
        'kycCompletionDate': value['kycCompletionDate'] == null ? undefined : ((value['kycCompletionDate']).toISOString()),
        'fileIds': value['fileIds'],
        'state': value['state'],
    };
}

